import { useEffect } from 'react';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/power-stream/detail/pc/');

export default function SectionG() {
    const { t } = useLang('powerstream.detail.sectionG');

    useEffect(() => {
        AniContainer.create({
            asyncFromTo: [
                ['.g-section .road-img .ef-picture_build', { scale: 1.2 }, { scale: 1 }, 1],
                ['.g-section .drilling-img .ef-picture_build', { scale: 1.2 }, { scale: 1 }, 1],
            ],
            triggerElement: '.g-section',
            offset: '20%',
            duration: '150%',
            triggerHook: 1,
            asyncTimeLine: [0, 0],
        });
    }, []);

    return (
        <div className={styles.sectionG}>
            <div className="g-section">
                <div className="common-card road-card">
                    <div className="card-img road-img">
                        <EFPic name={['sectionG_1.webp', 'sectionG_1.jpg']} />
                    </div>
                    <div className="card-text">
                        <p className="title">{t('title1')}</p>
                        <p className="desc">{t('desc1')}</p>
                    </div>
                </div>
                <div className="common-card drilling-card">
                    <div className="card-text">
                        <p className="title">{t('title2')}</p>
                        <p className="desc">{t.rich('desc2', { HighLight: (text: any) => <span className="green-text">{text}</span> })}</p>
                    </div>
                    <div className="card-img drilling-img">
                        <EFPic name={['sectionG_2.webp', 'sectionG_2.jpg']} />
                    </div>
                </div>
            </div>
        </div>
    );
}
